import React from 'react'
import { Form, Field, reduxForm } from 'redux-form'
import RenderFormField from 'components/render-form-field'
import { requiredField } from 'util/field-validation'
import SubmitButton from 'components/buttons/submit-button'

const LinkForm = ({ submitting, loading, error, handleSubmit }) => {
  const submitDisabled = submitting || loading

  const formError = error ? (
    <div data-ext='form--error-link' className='form--error'>
      {error}
    </div>
  ) : null

  return (
    <Form
      id='ext--link-form'
      data-test-key='link-form'
      className='form'
      method='POST'
      noValidate='novalidate'
      onSubmit={handleSubmit}
    >
      <Field
        name='username'
        placeholder='Username'
        component={RenderFormField}
        type='text'
        autoFocus
        validate={requiredField}
      />
      <Field
        name='password'
        placeholder='Password'
        component={RenderFormField}
        type='password'
        validate={requiredField}
      />

      {formError}

      <div className='form-group'>
        <SubmitButton
          text='Link'
          loading={submitDisabled}
          disabled={submitDisabled}
          testKey='link-submit'
        />
      </div>
    </Form>
  )
}

export default reduxForm({
  form: 'link',
  destroyOnUnmount: true,
  touchOnBlur: false,
  touchOnChange: true,
})(LinkForm)
